if (!customElements.get("rotating-images")) {
  customElements.define(
    "rotating-images",
    class RotatingImages extends BulkAdd {
      constructor() {
        super();

        const CURRENT_CLASS = "current";

        this.setPOVLogosWidth();
        window.addEventListener("resize", () => {
          this.setPOVLogosWidth();
        });

        setInterval(() => {
          let currentLogo = this.querySelector(".current"),
              nextLogo = currentLogo.nextElementSibling
                ? currentLogo.nextElementSibling
                : this.firstElementChild;
          currentLogo.classList.remove(CURRENT_CLASS);
          nextLogo.classList.add(CURRENT_CLASS);
        }, 1500);
      }

      setPOVLogosWidth() {
        let povLogos = this.querySelectorAll(".rotating-logo"),
          logoWidths = Array.from(povLogos).map((logo) => logo.offsetWidth),
          maxLogosWidth = Math.max(...logoWidths);

        this.style.setProperty("--width-rotating-images", `${maxLogosWidth}px`);
      }
    }
  );
}
